var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9564 1.58763C20.8529 0.5705 18.493 0 15.9999 0C13.5068 0 11.1469 0.5705 9.04341 1.58763L7.6521 16L9.04341 30.4124C11.1469 31.4295 13.5068 32 15.9999 32C18.493 32 20.8529 31.4295 22.9564 30.4124L24.3477 16L22.9564 1.58763Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.5882C3.69163 4.17613 0 9.65669 0 16C0 22.3433 3.69163 27.8239 9.0435 30.4118V1.5882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.5882V30.4118C28.3084 27.8239 32 22.3433 32 16C32 9.65669 28.3084 4.17613 22.9565 1.5882Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4348C12.9264 10.4348 10.4348 12.9264 10.4348 16C10.4348 19.0736 12.9264 21.5652 16 21.5652C19.0736 21.5652 21.5652 19.0736 21.5652 16C21.5652 12.9264 19.0736 10.4348 16 10.4348ZM16 19.4783C14.079 19.4783 12.5218 17.9209 12.5218 16C12.5218 14.0791 14.0791 12.5218 16 12.5218C17.9209 12.5218 19.4783 14.0791 19.4783 16C19.4783 17.9209 17.921 19.4783 16 19.4783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.913C15.2315 13.913 14.6086 14.5359 14.6086 15.3043V17.3913H17.3913V15.3043C17.3913 14.5359 16.7684 13.913 16 13.913V13.913Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/AF.826b8f75.svg";
export { ForwardRef as ReactComponent };